import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "@material-ui/icons/Edit";
import { Button, Paper, Grid, makeStyles, Typography } from "@material-ui/core";
import { Input, Select } from "antd";
import { useHistory, useLocation } from "react-router-dom";

import proPic from "../../../images/Card_Profile_Orange.svg";
import {
  getEmailSettings,
  updateEmailSettings,
} from "../../../actions/admin-actions";
import Loading from "../../../common-components/Loading";
import {
  getResponse,
  formatDateBySetting,
} from "../../../shared-resources/utils";
import {
  emailSettingOptions,
  emailSettingsTimeZones,
  managerWeeks,
  pmWeeks,
} from "../../../shared-resources/dumpData";
import ActionMessages from "../../../common-components/ActionMessages";
import Delegations from "./Delegations";

const UserProfile = () => {
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      marginTop: "12px",
      padding: "15px",
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    personalDetails: {
      padding: theme.spacing(2),
    },
    profilePicture: {
      width: "150px",
      height: "124px",
      borderRadius: "50%",
    },
    inputWithPadding: {
      height: "35px",
      marginTop: "20px",
      padding: "10px",
    },
    editIcon: {
      color: "#0070D2",
      fontSize: "16px",
      float: "left",
      marginTop: "2px",
    },
    editText: {
      color: "#0070D2",
      marginLeft: "4px",
      fontWeight: 600,
      fontSize: "15px",
    },
    editBtn: {
      border: "1px solid #0070D2",
      borderRadius: "20px",
      padding: "4px 8px",
      position: "absolute",
      cursor: "pointer",
      right: "12px",
      top: "12px",
    },
    cancelBtn: {
      border: "1px solid #0070D2",
      borderRadius: "20px",
      padding: "4px 8px",
      position: "absolute",
      cursor: "pointer",
      right: "76px",
      top: "12px",
    },
    companyDetails: {
      display: "flex",
      justifyContent: "space-between",
      padding: "5px",
      borderBottom: "1px solid #827575",
      marginBottom: "2px",
    },
    companyDetailsLast: {
      display: "flex",
      justifyContent: "space-between",
      padding: "5px",
    },

    label: {
      marginRight: "10px",
    },
    code: {},
    subLabel: {
      fontSize: "14px",
      fontWeight: 600,
      margin: "8px 0 0 0",
    },
    createBtnNew: {
      fontSize: "12px",
      padding: "4px 8px !important",
      textTransform: "none",
      background: "#0176D3",
      marginRight: "8px",
    },
    cancelBtnNew: {
      fontSize: "12px",
      padding: "3px 8px !important",
      textTransform: "none",
      border: "0.5px solid #0176D3",
      color: "#0176D3",
    },
  }));

  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  //  const [userId, setUserId] = useState("");
  const [dateFormat, setDateFormat] = useState("");
  const [editedUserInfo, setEditedUserInfo] = useState({
    name: "",
    position: "",
    phone: "",
    email: "",
    doj: "",
    location: "",
  });
  const [isSaveClick, setIsSaveClick] = useState(false);
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [formData, setFormData] = useState({
    projectManagerDayOfTheWeek: "",
    projectManagerEmailFrequency: "",
    resourceManagerDayOfTheWeek: "",
    resourceManagerEmailFrequency: "",
    timezone: "",
  });
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();

  const [userInfo, setUserInfo] = useState({
    name: "",
    position: "",
    phone: "",
    email: "",
    doj: "",
    location: "",
  });
  const generalSettingsData = useSelector(
    (state) => state.adminReducer.generalSettingsData
  );
  const profileDetails = useSelector(
    (state) => state.resourceManagementReducer.profileDetails
  );
  const emailSettingsData = useSelector(
    (state) => state.adminReducer.emailSettingsData
  );
  const updatedEmailSettingsData = useSelector(
    (state) => state.adminReducer.updatedEmailSettingsData
  );

  const getUserInfo = () => {
    if (
      profileDetails &&
      profileDetails.data &&
      Array.isArray(profileDetails.data.data)
    ) {
      return profileDetails.data.data.reduce((info, field) => {
        info[field.fieldName.toLowerCase()] = field.fieldValue;
        return info;
      }, {});
    }
    return {};
  };

  useEffect(() => {
    setLoading(true);
    //dispatch(getUserProfileDetails(localStorage.getItem("email")));
    dispatch(getEmailSettings());
  }, []);

  useEffect(() => {
    if (emailSettingsData.status && emailSettingsData.status === 200) {
      setFormData(emailSettingsData.data);
    }
  }, [emailSettingsData]);

  useEffect(() => {
    if (
      updatedEmailSettingsData.status &&
      updatedEmailSettingsData.status === 200
    ) {
      setLoading(false);
      setEmptyErrMsg(true);
      setMsgText("Email settings updated successfully");
      setMsgType("success");
    }
  }, [updatedEmailSettingsData]);

  useEffect(() => {
    if (getResponse(generalSettingsData, []).length > 0)
      setDateFormat(getResponse(generalSettingsData, [])[0].date_format);
  }, [generalSettingsData]);

  useEffect(() => {
    if (
      profileDetails &&
      profileDetails.status &&
      profileDetails.status === 200
    ) {
      setUserInfo(getUserInfo());
    } else if (profileDetails.status === 400) {
      setUserInfo([]);
    }
  }, [profileDetails]);

  useEffect(() => {
    if (
      profileDetails &&
      profileDetails.status &&
      profileDetails.status === 200 &&
      emailSettingsData &&
      emailSettingsData.status &&
      emailSettingsData.status === 200
    ) {
      setLoading(false);
    }
  }, [emailSettingsData, profileDetails]);

  const handleEdit = () => {
    setIsEditing(true);
    setEditedUserInfo(userInfo);
  };
  const handleSave = () => {
    setUserInfo(editedUserInfo);
    setIsEditing(false);
  };
  const handleCancel = () => {
    setIsEditing(false);
  };

  const userInformation = isEditing ? editedUserInfo : getUserInfo();
  const renderDetails = () => {
    const includedKeys = [
      "first name",
      "last name",
      "email",
      "phone",
      "department",
      "location",
      "role",
      "skills",
      "employee location",
      "employment type",
      "reporting manager",
      "date of join",
    ];

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0px",
          fontSize: "14px",
        }}
      >
        {Object.entries(userInformation).map(
          ([key, value]) =>
            includedKeys.includes(key) && (
              <div key={key} style={{ marginBottom: "10px", flex: "1 1 48%" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span
                    style={{
                      fontWeight: 600,
                      marginRight: "20px",
                      color: "black",
                      marginTop: "10px",
                    }}
                  >
                    {key.charAt(0).toUpperCase() + key.slice(1)}:
                  </span>
                  {key === "date of join" ? (
                    <span style={{ marginTop: "10px" }}>
                      {formatDateBySetting(new Date(value), dateFormat)}
                    </span>
                  ) : (
                    <span style={{ marginTop: "10px" }}>{value}</span>
                  )}
                </div>
              </div>
            )
        )}
      </div>
    );
  };

  const renderInputs = () => {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          fontSize: "14px",
        }}
      >
        {Object.entries(userInformation).map(([key, value]) => (
          <div key={key} style={{ marginBottom: "20px", flex: "1 1 48%" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  fontWeight: 600,
                  marginRight: "20px",
                  color: "black",
                  marginTop: "20px",
                }}
              >
                {key.charAt(0).toUpperCase() + key.slice(1)}:
              </span>
              <Input
                value={value}
                className={classes.inputWithPadding}
                onChange={(e) =>
                  setEditedUserInfo({
                    ...editedUserInfo,
                    [key]: e.target.value,
                  })
                }
              />
            </div>
          </div>
        ))}
      </div>
    );
  };

  const onDdlChange = (val, key) => {
    if (key === "resourceManagerEmailFrequency")
      setFormData({
        ...formData,
        resourceManagerEmailFrequency: val,
        resourceManagerDayOfTheWeek: "Monday",
      });
    else if (key === "projectManagerEmailFrequency")
      setFormData({
        ...formData,
        projectManagerEmailFrequency: val,
        projectManagerDayOfTheWeek: "Monday",
      });
    else
      setFormData({
        ...formData,
        [key]: val,
      });
    setIsSaveEnabled(true);
  };

  const onSaveClick = () => {
    setIsSaveEnabled(false);
    setLoading(true);
    dispatch(updateEmailSettings(formData));
  };

  const onCancelClick = () => {
    setIsSaveEnabled(false);
    setFormData(emailSettingsData.data);
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  return (
    <>
      {userInfo.length === 0 ? (
        <>
          <Paper
            style={{
              marginTop: "16px",
              textAlign: "center",
              padding: "32px 0",
            }}
          >
            No Data
          </Paper>
        </>
      ) : (
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={3}>
              <Paper elevation={1} className={classes.paper}>
                <img
                  src={proPic}
                  alt="Profile"
                  className={classes.profilePicture}
                />
                <Typography variant="h6" style={{ color: "black" }}>
                  {`${userInfo["first name"]} ${userInfo["last name"]}`}
                </Typography>
                <Typography variant="h6">{userInfo.role}</Typography>
                {/* <div style={{ textAlign: "left", marginTop: "10px" }}>
                  {Object.keys(userInfo).map((key) => {
                    if (
                      key === "first name" ||
                      key === "last name" ||
                      key === "role"
                    ) {
                      return null;
                    }

                    return (
                      <React.Fragment key={key}>
                        <Typography
                          style={{ marginTop: "10px", fontWeight: 500 }}
                          variant="body2"
                        >
                          {key.charAt(0).toUpperCase() + key.slice(1)} :
                        </Typography>
                        {key === "date of join" ? (
                          <Typography>
                            {formatDateBySetting(
                              new Date(userInfo[key]),
                              dateFormat
                            )}
                          </Typography>
                        ) : (
                          <Typography>{userInfo[key]}</Typography>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div> */}
              </Paper>
              <Paper
                elevation={1}
                className={classes.personalDetails}
                style={{ position: "relative", marginTop: "8px" }}
              >
                <div style={{ height: "auto" }}>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: "18px",
                      color: "#0072DB",
                    }}
                  >
                    Self Service Settings
                  </span>
                  <Grid container spacing={1}>
                    <Grid item lg={12} className={classes.subLabel}>
                      Manager Email Frequency
                    </Grid>
                    <Grid item lg={12}>
                      <Select
                        showSearch
                        mode="single"
                        style={{ width: "100%", zIndex: 9 }}
                        placeholder="Search to Select"
                        showArrow
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label.toLowerCase() ?? "").includes(
                            input.toLowerCase()
                          )
                        }
                        options={emailSettingOptions}
                        onChange={(val) =>
                          onDdlChange(val, "resourceManagerEmailFrequency")
                        }
                        value={formData.resourceManagerEmailFrequency}
                      />
                    </Grid>
                    {formData.resourceManagerEmailFrequency === "Weekly" && (
                      <Grid item lg={12}>
                        <Select
                          showSearch
                          mode="single"
                          style={{ width: "100%", zIndex: 9 }}
                          placeholder="Search to Select"
                          showArrow
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label.toLowerCase() ?? "").includes(
                              input.toLowerCase()
                            )
                          }
                          options={managerWeeks}
                          onChange={(val) =>
                            onDdlChange(val, "resourceManagerDayOfTheWeek")
                          }
                          value={formData.resourceManagerDayOfTheWeek}
                        />
                      </Grid>
                    )}

                    <Grid item lg={12} className={classes.subLabel}>
                      Project Manager Email Frequency
                    </Grid>
                    <Grid item lg={12}>
                      <Select
                        showSearch
                        mode="single"
                        style={{ width: "100%", zIndex: 9 }}
                        placeholder="Search to Select"
                        showArrow
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label.toLowerCase() ?? "").includes(
                            input.toLowerCase()
                          )
                        }
                        options={emailSettingOptions}
                        onChange={(val) =>
                          onDdlChange(val, "projectManagerEmailFrequency")
                        }
                        value={formData.projectManagerEmailFrequency}
                      />
                    </Grid>
                    {formData.projectManagerEmailFrequency === "Weekly" && (
                      <Grid item lg={12}>
                        <Select
                          showSearch
                          mode="single"
                          style={{ width: "100%", zIndex: 9 }}
                          placeholder="Search to Select"
                          showArrow
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label.toLowerCase() ?? "").includes(
                              input.toLowerCase()
                            )
                          }
                          options={pmWeeks}
                          onChange={(val) =>
                            onDdlChange(val, "projectManagerDayOfTheWeek")
                          }
                          value={formData.projectManagerDayOfTheWeek}
                        />
                      </Grid>
                    )}

                    <Grid item lg={12} className={classes.subLabel}>
                      Time Zone
                    </Grid>
                    <Grid item lg={12}>
                      <Select
                        showSearch
                        mode="single"
                        style={{ width: "100%", zIndex: 9 }}
                        placeholder="Search to Select"
                        showArrow
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label.toLowerCase() ?? "").includes(
                            input.toLowerCase()
                          )
                        }
                        options={emailSettingsTimeZones}
                        onChange={(val) => onDdlChange(val, "timezone")}
                        value={formData.timezone}
                      />
                    </Grid>
                    <Grid item lg={12} style={{ textAlign: "center" }}>
                      <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        disableElevation
                        className={classes.createBtnNew}
                        onClick={onSaveClick}
                        disabled={!isSaveEnabled}
                      >
                        Save
                      </Button>
                      <Button
                        variant="outlined"
                        className={classes.cancelBtnNew}
                        color="primary"
                        onClick={onCancelClick}
                        disabled={!isSaveEnabled}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </Paper>
            </Grid>
            <Grid item xs={9}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Paper
                    elevation={1}
                    className={classes.personalDetails}
                    style={{ position: "relative" }}
                  >
                    <div style={{ height: "auto" }}>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#0072DB",
                        }}
                      >
                        Personal Details
                      </span>
                      {isEditing ? renderInputs() : renderDetails()}
                      {isEditing && (
                        <>
                          <div
                            className={classes.cancelBtn}
                            onClick={handleCancel}
                          >
                            <span className={classes.editText}>Cancel</span>
                          </div>
                          <div className={classes.editBtn} onClick={handleSave}>
                            <span className={classes.editText}>Save</span>
                          </div>
                        </>
                      )}
                      {isEditing && (
                        <div className={classes.editBtn} onClick={handleEdit}>
                          <EditIcon className={classes.editIcon} />
                          <span className={classes.editText}>Edit</span>
                        </div>
                      )}
                    </div>
                  </Paper>
                  <Paper
                    elevation={1}
                    style={{
                      position: "relative",
                      marginTop: "8px",
                      padding: "12px 4px",
                    }}
                  >
                    <div style={{ height: "auto" }}>
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "18px",
                          color: "#0072DB",
                          margin: "0 0 0 16px",
                        }}
                      >
                        Resource Delegations
                      </span>
                      <Delegations />
                    </div>
                  </Paper>
                </Grid>
                {/* <Grid item xs={12}>
                <Paper elevation={1} className={classes.personalDetails}>
                  <div
                    style={{
                      marginBottom: "20px",
                      fontWeight: "bold",
                      fontSize: "18px",
                      color: "#0072DB",
                    }}
                  >
                    <span>Company Details</span>
                  </div>
                  <div className={classes.companyDetails}>
                    <Typography variant="body2">Employment Code:</Typography>
                    <Typography variant="body1">1616515</Typography>
                  </div>
                  <div className={classes.companyDetails}>
                    <Typography variant="body2">Role:</Typography>
                    <Typography variant="body1">Frontend Developer</Typography>
                  </div>
                  <div className={classes.companyDetails}>
                    <Typography variant="body2">Department:</Typography>
                    <Typography variant="body1">IT</Typography>
                  </div>
                  <div className={classes.companyDetailsLast}>
                    <Typography variant="body2">
                      Contract start date:
                    </Typography>
                    <Typography variant="body1">yyyy/mm/dd</Typography>
                  </div>
                </Paper>
              </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
      {loading && <Loading />}
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
    </>
  );
};
export default UserProfile;
